import { FC } from "react";
import { ArrowRightIcon, GiftIcon, LockIcon } from "shared/ui/icons";
import type { RaffleRole } from "../model/selectHistory";
import type { RaffleBadgeSource } from "../model/cardBadge";
import type { RaffleBase } from "../model/types";
import { RaffleCardBadge } from "./RaffleCardBadge";
import { RaffleCardStats } from "./RaffleCardStats";

import styles from "./RaffleCard.module.css";

type RaffleCardData = Pick<
  RaffleBase,
  | "id"
  | "visibility"
  | "prize_pool_usdt"
  | "participants_count"
  | "ends_at"
  | "drawn_at"
  | "my_prize_usdt"
> &
  RaffleBadgeSource;

interface Props {
  raffle: RaffleCardData;
  // Для превью: у несозданного розыгрыша нет ни id, ни идущего таймера.
  title?: string;
  timeLeft?: string;
  // Подсветка роли зрителя: свои и чужие розыгрыши разного цвета.
  role?: RaffleRole | null;
  onClick?: (raffleId: number) => void;
}

export const RaffleCard: FC<Props> = ({
  raffle,
  title = `Promo #${raffle.id}`,
  timeLeft,
  role = null,
  onClick,
}) => (
  <div className={`${styles.card} ${role ? styles[role] : ""}`}>
    <span className={styles.header}>
      <span className={styles.title}>{title}</span>
      <RaffleCardBadge raffle={raffle} role={role} />
    </span>
    <span className={styles.poolRow}>
      <span className={styles.pool}>
        <span className={styles.label}>Prize pool</span>
        <span className={styles.poolValue}>{raffle.prize_pool_usdt} USDT</span>
      </span>
      {raffle.visibility === "private" && (
        <span
          className={styles.lock}
          role="img"
          aria-label="Private"
          title="Private"
        >
          <LockIcon />
        </span>
      )}
    </span>
    {raffle.my_prize_usdt && (
      <span className={styles.prize}>
        <GiftIcon fill="currentColor" width={16} height={16} aria-hidden />
        You won {raffle.my_prize_usdt} USDT
      </span>
    )}
    <RaffleCardStats
      participantsCount={raffle.participants_count}
      endsAt={raffle.ends_at}
      drawnAt={raffle.drawn_at}
      timeLeft={timeLeft}
    />
    {onClick && (
      <button
        type="button"
        className={styles.view}
        onClick={() => onClick(raffle.id)}
      >
        View promo
        <ArrowRightIcon className={styles.arrow} aria-hidden="true" />
      </button>
    )}
  </div>
);
